import { Dossier } from '@/app/dossier/entities/dossier.entity'

export interface DossierState {
    dossier?: Dossier
}

export const state: DossierState = {
    dossier: undefined
}
